import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { TreeSelect } from 'antd';
import './RDMultiSelect.scss';

const { SHOW_CHILD } = TreeSelect;

const RDMultiSelect = ({
  data,
  disabled,
  selectedKeys,
  handleChange,
  multiSelectStyle,
  selectedThreshold,
  placeholder,
  thresholdPlaceholder,
}) => {
  const [options] = useState(data?.map((item) => ({ key: item, title: item, value: item })));

  return (
    <TreeSelect
      treeData={[
        {
          title: `All ${placeholder}`,
          key: 'all',
          value: 'all',
          children: [...options],
        },
      ]}
      value={selectedKeys}
      onChange={handleChange}
      treeDefaultExpandAll
      placeholder={`Select ${placeholder}`}
      disabled={disabled}
      treeCheckable
      showCheckedStrategy={SHOW_CHILD}
      style={multiSelectStyle}
      maxTagPlaceholder={thresholdPlaceholder || `+ ${selectedKeys.length - selectedThreshold}`}
      maxTagCount={selectedThreshold}
    />
  );
};

RDMultiSelect.defaultProps = {
  data: [],
  disabled: false,
  selectedKeys: [],
  multiSelectStyle: { width: '100%' },
  placeholder: '',
  selectedThreshold: 2,
  thresholdPlaceholder: '',
};

RDMultiSelect.propTypes = {
  /** MultiSelect options */
  data: PropTypes.arrayOf(PropTypes.string),
  /** Called when select an option */
  handleChange: PropTypes.func.isRequired,
  /** Whether disabled tree */
  disabled: PropTypes.bool,
  /** Current selected options */
  selectedKeys: PropTypes.arrayOf(PropTypes.string),
  /** Inline MultiSelect style */
  multiSelectStyle: PropTypes.shape({}),
  /** MultiSelect placeholder */
  placeholder: PropTypes.string,
  /** Max tag count to show. */
  selectedThreshold: PropTypes.number,
  /** Max tag placeholder. */
  thresholdPlaceholder: PropTypes.string,
};

export default RDMultiSelect;
